import React from 'react'
import { Box, Flex, Divider } from 'rebass'
import { colors, fonts, fontSizes, fontWeights } from '../theme'
import styled from 'styled-components'
import Title from '../elements/Text/Title'

const DetailsContainer = styled(Box)`
  font-family: ${fonts.secondary};
  font-size: ${fontSizes[3] + 'px'};
  &:first-letter {
    font-weight: bold;
    font-size: ${fontSizes[6] + 'px'};
  }
  color: ${colors.greyDark};
`
const TextSeparator = styled(Divider)`
  width: 30px;
  height: 5px;
  background-color: ${colors.secondary};
  border-bottom: none;
  border-radius: 15px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
`
const Team = () => (
  <Box px={5} py={6} style={{ textAlign: 'center' }}>
    <Title color={colors.primary}>Our Team</Title>
    <TextSeparator />
    <DetailsContainer>
      The Firm comprises of partners and a multi-disciplinary team of of
      chartered accountants , company secretaries, Advocates, Retired Ex-
      bankers, MBA and other professionals, in their chosen field of expertise,
      assisted by motivated and well-qualified support staff. We are passionate
      about what we do and are highly motivated to achieve successful results,
      desired by our clients.
    </DetailsContainer>
    <Divider pt={3} mb={5} />
    <Title color={colors.primary} fontSize={fontSizes[4] + 'px'}>
      CA. SHUBHAM JAIN, Managing Partner
    </Title>
    <TextSeparator />
    <DetailsContainer>
      B.Com; A.C.A. (Associate Member of the Institute of Chartered Accountants
      of India) Mr. Jain specialises in Income tax matters – Compliance,
      advisory & litigation . He regularly advises clients on their complex
      issues. Mr. Jain is also well versed with GST law and helped the various
      clients operating under different industries in GST implementation and
      helping them in carrying out their business activities in compliance with
      GST law. In past, he has been part of one of the big 4 accounting firms
      viz. Ernst & Young LLP as a Transfer Pricing Consultant. He is a regular
      speaker on income tax and GST matter at various chamber of commerce and
      forums. Mr. Jain is the founder of JAIN S N & CO. This is an online
      platform in order to encourage young entrepreneurs in their startups by
      reducing their statutory compliance burden. Mr. Jain is a regular writer
      on tax matters. He has written various articles on direct tax and GST
      matters. His written articles has been published by Taxmann Publications
      on their portal and magazines.
    </DetailsContainer>
    <Divider pt={3} mb={5} />
    <Title color={colors.primary} fontSize={fontSizes[4] + 'px'}>
      {' '}
      CA NATASHA JAIN, Partner{' '}
    </Title>
    <TextSeparator />
    <DetailsContainer>
      B.Com; F.C.A. (Fellow Member of the Institute of Chartered Accountants of
      India); DISA (ICAI) Ms.Natasha has extensive experience of over six years
      in statutory audits, internal audits & bank audits. She also has
      experience in handling search & seizure cases and has represented numerous
      clients before Income tax authorities (Till ITAT level) In addition to his
      vast practice, Ms. Natasha is a frequent speaker at various conferences
      and knowledge events.
    </DetailsContainer>
    <Divider pt={3} mb={5} />
    <Title color={colors.primary} fontSize={fontSizes[4] + 'px'}>
      {' '}
      PRAVEEN KUMAR JAIN, Senior Legal Advisor{' '}
    </Title>
    <TextSeparator />
    <DetailsContainer>
      Shri Jain is a senior legal advisor of the firm with two decades of
      extensive experience in handling numerous clients and advising them in
      their legal and litigative matters. Shri Jain has vast experience of
      indirect tax – VAT & GST. He has represented clients in their litigation
      matters till appellate authority. His knowledge and experience has always
      helped the firm in giving advisory to clients to the extent of their
      needs.
    </DetailsContainer>
  </Box>
)

export default Team



// WEBPACK FOOTER //
// ./src/pages/team.js